import './mailingsTypes';
import './mailingsTypes-list';
import './mailingsTypes-edit';